import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "dangerAll",
  "use": "dangerAll-usage",
  "viewBox": "0 0 17.59 20",
  "content": "<symbol viewBox=\"0 0 17.59 20\" id=\"dangerAll\"><title>dangerAll</title><path d=\"M9.49.14,1.71,4.63a1,1,0,0,0-.51.88v9a1,1,0,0,0,.51.88l7.78,4.49a1,1,0,0,0,1,0l7.78-4.49a1,1,0,0,0,.51-.88v-9a1,1,0,0,0-.51-.88L10.51.14A1,1,0,0,0,9.49.14ZM15.66,10a.86.86,0,0,1-.86.86H5.19A.86.86,0,0,1,4.34,10V10a.86.86,0,0,1,.86-.86h9.61a.86.86,0,0,1,.86.86Z\" transform=\"translate(-1.2 0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/dangerAll.svg
// module id = rs4T
// module chunks = 264